import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Import Tailwind CSS
import App from './App';
import './performance.css'; // Performance optimizations

const root = ReactDOM.createRoot(document.getElementById('root'));

// Disable console methods in production
console.log = () => {};
// console.warn = () => {};
// console.error = () => {};
console.info = () => {};

root.render(
  <App />
);